import { createStore } from 'vuex'

var URL = 'https://server-web.konaweselatankab.go.id/';
var URLS = 'https://diskominfo.konaweselatankab.go.id/';

var UNIT = 'EtTbFb6EzYZt9mMJL';

export default createStore({
  state: {
    UNIT_KERJA : UNIT,
    url : {
      URL : URLS,
      URL_APP : URL,
      URL_SLIDER : URL + 'api/v1/publish_diskominfo_slider/',
      URL_SAMBUTAN : URL + 'api/v1/publish_diskominfo_sambutan/',
      URL_BERITA : URL + 'api/v1/web_publish_berita/',
      URL_FOTO : URL + 'api/v1/publish_diskominfo_foto/',
      URL_VIDEO : URL + 'api/v1/publish_diskominfo_video/',
      URL_PROFIL : URL + 'api/v1/publish_diskominfo_tentang/',
      URL_VISI : URL + 'api/v1/publish_diskominfo_visi_misi/',
      URL_STRUKTUR : URL + 'api/v1/publish_diskominfo_struktur_organisasi/',
      URL_TUPOKSI : URL + 'api/v1/publish_diskominfo_tupoksi/',
      URL_LINK : URL + 'api/v1/web_publish_link_terkait/',
      URL_PEJABAT : URL + 'api/v1/publish_diskominfo_profilstruktural/',
      URL_BERITA : URL + 'api/v1/web_publish_berita/',
      URL_BIDANG : URL + 'api/v1/publish_diskominfo_bidang/',
      URL_INFOGRAFIS : URL + 'api/v1/publish_diskominfo_infografis/',
      URL_PERATURAN : URL + 'api/v1/publish_diskominfo_peraturan/',
      URL_DOKUMEN : URL + 'api/v1/publish_diskominfo_dokumen/',
      URL_SOP : URL + 'api/v1/publish_diskominfo_sop/',
      URL_FOTO : URL + 'api/v1/publish_diskominfo_foto/',
      URL_VIDEO : URL + 'api/v1/publish_diskominfo_video/',
      URL_LAPORAN : URL + 'api/v1/publish_diskominfo_laporan/',
      URL_PETA : URL + 'api/v1/publish_diskominfo_peta/',
      URL_KONTAK : URL + 'api/v1/publish_diskominfo_kontak/',
    }
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
